// 页面上显示的分数（WQI、OTA 评分、分类分、竞品分、均值、目标值……）默认 1 位小数，
// 原值有第 2 位小数时显示 2 位；再多的位数直接截掉、不四舍五入。满分 10 显示 "10"。
//   9 → 9.0，8.2 → 8.2，8.25 → 8.25，8.256 → 8.25，9.967 → 9.96，10 → 10
// 只包显示文本：颜色分档、阈值比较、排序继续用原始数字，别拿这里返回的字符串去算。

export const SCORE_DIGITS = 2

// 截断到 digits 位小数，返回数字。分数在算均值 / 差值前要先取位数、又要和显示一致时用它，
// 别用 Math.round。加一点点再截断：2.3 * 10 在浮点里是 22.999999999999996。
export function truncScore(value, digits = SCORE_DIGITS) {
  const n = Number(value)
  if (!Number.isFinite(n)) return n
  const p = Math.pow(10, digits)
  return Math.trunc(n * p + (n >= 0 ? 1e-9 : -1e-9)) / p
}

export function formatScore(value, { digits = SCORE_DIGITS, empty = '-' } = {}) {
  if (value == null || value === '') return empty
  const n = Number(value)
  if (!Number.isFinite(n)) return empty
  const t = truncScore(n, digits)
  if (t === 10) return '10'
  // 末尾的 0 去掉，但至少留 1 位：8.20 → 8.2，9.00 → 9.0
  let str = t.toFixed(digits)
  while (str.endsWith('0') && str.split('.')[1].length > 1) str = str.slice(0, -1)
  return str
}

export function installScoreFormat(Vue) {
  Vue.prototype.$fmtScore = formatScore
}
